module.exports = __webpack_public_path__ + "assets/img/61.0dec0d79.png";